import React from "react";
import styled from "styled-components";
import {authorBackgroundColour, headingColour, subduedTextColour} from "../../style/styleConsts";

export const SectionTitle = styled.div`
    display: flex;
    flex-shrink: 0;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    color: ${headingColour};
    background-color: ${authorBackgroundColour};
    font-size: 24px;
    border-bottom: 1px solid #d6d0c8;
    height: 46px;
`;

export const Title = styled.div`
    padding-right: 8px;
    font-size: 22px;
`;

export const Headings = styled.div`
    display: flex;
    flex-shrink: 0;
    flex-grow: 0;
    align-items: center;
    justify-content: stretch;
    background-color: ${authorBackgroundColour};
    font-weight: bold;
    border-bottom: 1px solid #d6d0c8;
`;

export const ColumnNameHeadings = styled(Headings)`
    flex-grow: 1;
    padding-top: 0;
    padding-bottom: 0;
    border-bottom: none;
    font-weight: normal;
`;

export const PillContainer = styled.div`
    color: ${subduedTextColour};
    padding: 0 6px;
    font-size: 12px;
`;

export const DataRefreshRatePill = ({className}) => (
    <PillContainer className={className}>
        *Data updates hourly
    </PillContainer>
);